// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__15fRD","heading":"Container_heading__2ofhv","text":"Container_text__2HEN4"};